import React from "react";
import {
  faSort,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

export type SortRequestedEvent = {
  columnName?: string;
  currentSortOrder: "asc" | "desc";
};

export type SortColumnHeaderProps = {
  columnName?: string;
  text?: string;
  hint?: string;
  active?: boolean;
  sortOrder?: "asc" | "desc";
  onSortRequested?: (params: SortRequestedEvent) => void;
};

function SortColumnHeader({
  text = "",
  hint,
  active = false,
  sortOrder = "asc",
  columnName,
  onSortRequested = () => {},
}: SortColumnHeaderProps) {
  const button = (
    <Button
      variant="link"
      className={
        "p-0 text-decoration-none text-dark font-weight-bold d-inline-flex align-items-center"
      }
      onClick={() =>
        onSortRequested({ columnName, currentSortOrder: sortOrder })
      }
    >
      {text}
      <div className="fa-stack small" style={{ height: "1em" }}>
        <FontAwesomeIcon
          icon={faSort}
          color={"#ccc"}
          fixedWidth
          className="fa-stack-1x"
        />
        {active && sortOrder === "asc" && (
          <FontAwesomeIcon icon={faSortUp} fixedWidth className="fa-stack-1x" />
        )}
        {active && sortOrder === "desc" && (
          <FontAwesomeIcon
            icon={faSortDown}
            fixedWidth
            className="fa-stack-1x"
          />
        )}
      </div>
    </Button>
  );

  if (!hint) {
    return button;
  }

  return (
    <OverlayTrigger
      placement="bottom"
      trigger={["hover", "focus"]}
      overlay={
        <Tooltip id={`sort-header-${columnName ?? text}`}>{hint}</Tooltip>
      }
    >
      {button}
    </OverlayTrigger>
  );
}

export default SortColumnHeader;
